<h1 mat-dialog-title>Manage scoped access</h1>
<div class="user-summary">
    <strong>{{user.firstName}} {{user.lastName}}</strong>
    <div>{{user.email}}</div>
    <div class="identifier">User ID: {{user.id}}</div>
</div>
<div class="dormant-notice" role="note">{{state.warning}}</div>
<div mat-dialog-content>
  <p *ngIf="state.invalidated" role="alert">Session, user, or API environment changed. Close and reopen this dialog.</p>
  <p *ngIf="state.catalogError" role="alert">{{state.catalogError}}</p>
  <p *ngIf="state.companyError" role="alert">{{state.companyError}}</p>
  <p *ngIf="state.mutationError" role="alert">{{state.mutationError}}</p>
  <p *ngIf="state.success" role="status">{{state.success}}</p>
  <ng-container *ngIf="state.current">
    <section aria-label="Record assignment" class="grant-form">
      <p><strong>{{state.bundle?.label || 'Payroll operations'}}</strong></p>
      <p *ngIf="state.bundle">Catalog description: {{state.bundle?.description}}</p>
      <p>Record at one company, immediately and without expiry. Lifecycle status does not indicate actual access.</p>
      <mat-form-field appearance="outline">
        <mat-label>Company</mat-label>
        <mat-select [(value)]="state.companyId" [disabled]="state.saving || state.pending || state.loading"
                    panelClass="member-addedit-select-search-panel">
          <mat-option>
            <ngx-mat-select-search [formControl]="companySearch" placeholderLabel="Search companies or IDs..."
                                   noEntriesFoundLabel="No companies"></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let company of filteredCompanies" [value]="company.id">{{company.name || 'Unnamed company'}} — {{company.id}}</mat-option>
        </mat-select>
      </mat-form-field>
      <div *ngIf="state.companyId" class="identifier">Selected company ID: {{state.companyId}}</div>
      <button mat-raised-button color="primary" [disabled]="!state.canGrant" (click)="state.grant()">Record assignment</button>
    </section>
    <section aria-label="Assignment history">
      <h2>Recorded assignments</h2>
      <p>Assignment history; this is not a security audit log.</p>
      <mat-checkbox [checked]="state.includeHistory" [disabled]="state.saving || state.pending"
                    (change)="state.history($event.checked)">Include revoked and expired history</mat-checkbox>
      <div class="toolbar">
        <button mat-button [disabled]="state.loading || state.saving" (click)="state.load()">Refresh / first page</button>
        <button mat-button [disabled]="state.loading || state.saving || state.pending || !!state.listError || !state.page?.nextCursor"
                (click)="state.load(state.page?.nextCursor || null)">Next page</button>
        <span>Up to 25 rows per page</span>
      </div>
      <p *ngIf="state.loading" role="status">Loading current assignments…</p>
      <p *ngIf="state.saving" role="status">Recording operation…</p>
      <p *ngIf="state.listError" role="alert">{{state.listError}} <span *ngIf="state.success">The operation completed; the current list could not be reloaded.</span></p>
      <p *ngIf="state.page && (state.listError || state.needsReload)">Previously loaded rows below may be out of date.</p>
      <ng-container *ngIf="state.page && !state.loading">
        <p>Server enforcement status: {{state.page.enforcementStatus}} · Subject revision: {{state.page.revision}}</p>
        <p *ngIf="!state.page.assignments.length && !state.listError && !state.needsReload">No recorded assignments in this view.</p>
        <article *ngFor="let row of state.page.assignments" class="assignment">
          <strong>{{state.bundleLabel(row.bundleId)}}</strong>
          <div>{{state.companyLabel(row.scope.id)}}</div>
          <div class="identifier">{{row.scope.type}} ID: {{row.scope.id}}</div>
          <div>Recorded lifecycle: {{row.lifecycle}} (does not grant access)</div>
          <div>Created: {{row.createdAt | date:'medium'}} · Effective: {{row.effectiveAt | date:'medium'}}</div>
          <div>Expires: {{row.expiresAt ? (row.expiresAt | date:'medium') : 'No expiry'}}</div>
          <div *ngIf="row.revokedAt">Revoked: {{row.revokedAt | date:'medium'}}</div>
          <div class="identifier">Assignment ID: {{row.assignmentId}}</div>
          <p *ngIf="row.bundleId !== 'payroll_operations'">Historical bundle — display only.</p>
          <button *ngIf="row.bundleId === 'payroll_operations' && (row.lifecycle === 'effective' || row.lifecycle === 'scheduled')"
                  mat-button color="warn" [disabled]="!state.canRevoke(row)" (click)="state.revoke(row)">Revoke recorded assignment</button>
        </article>
      </ng-container>
    </section>
    <div *ngIf="state.uncertain" class="pending-notice">
      <p>The same attempt is retained only while this dialog is open. Closing discards its retry key; it does not cancel or undo an operation. Reopen and inspect history before considering another operation.</p>
      <button mat-raised-button [disabled]="!state.canRetry" (click)="state.retry()">Retry same attempt</button>
    </div>
  </ng-container>
</div>
<div mat-dialog-actions align="end"><button mat-button (click)="close()">Close</button></div>
